import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLazyGetPackingStyleDistributionQuery } from "../../../../services/Api";
import LoaderSpiner from "../../../../components/loaderSpiner";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const COLORS = ["#3D5673", "#5D733C", "#FFB14E", "#A192FA", "#F2C94C"];

export default function PackingStyleDistribution() {
  const [trigger, { isLoading, error }] =
    useLazyGetPackingStyleDistributionQuery();
  const [chartData, setChartData] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    if (!hasFetched) {
      setHasFetched(true);

      trigger()
        .unwrap()
        .then((response) => {
          if (response?.success) {
            // if (!toast.isActive("success-toast")) {
            //   toast.success("Data fetched successfully!", {
            //     toastId: "success-toast",
            //   });
            // }

            const formattedData =
              response?.data?.map((item) => ({
                name:
                  item.label &&
                  item.label.charAt(0).toUpperCase() +
                  item.label.slice(1).toLowerCase(),
                value: item.value,
              })) || [];

            setChartData(formattedData);
          }
        })
        .catch(() => {
          if (!toast.isActive("error-toast")) {
            toast.error("Unable to fetch data. Please check your connection.", {
              toastId: "error-toast",
            });
          }
        });
    }
  }, [trigger, hasFetched]);

  if (isLoading) {
    return <LoaderSpiner />;
  }

  if (error) {
    return <p>Error loading data. Please try again later.</p>;
  }

  return (
    <div className="bg-lightgreen p-6 rounded-[1.75rem] h-full">
      <h3 className="mb-4 font-['Roboto_Mono'] text-lg font-bold">
        Packing Style Distribution
      </h3>

      {/* Chart Section */}
      <div className="flex flex-col justify-center items-center relative">
        <PieChart width={200} height={200}>
          <Pie
            data={chartData}
            innerRadius={60}
            outerRadius={80}
            paddingAngle={0}
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            wrapperStyle={{
              fontSize: "14px",
              backgroundColor: "#000",
              color: "#fff",
            }}
            formatter={(value) => `${value}`}
          />
        </PieChart>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-[50%] flex justify-center items-center">
          <p className="text-2xl font-bold">
            {chartData.reduce((sum, item) => sum + item.value, 0)}
          </p>
        </div>
      </div>

      {/* Legend Section */}
      <div className="flex justify-center flex-col  mt-1 font-['Quicksand'] text-sm font-medium">
        {chartData.map((entry, index) => (
          <div
            key={entry.name}
            className="flex items-center justify-center w-full gap-2"
          >
            <div
              className="w-2 h-2 rounded-full shrink-0"
              style={{ backgroundColor: COLORS[index % COLORS.length] }}
            ></div>
            <span className="md:text-sm text-xs">{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
